import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Button } from "./ButtonBlock";
import { defaultData } from "./ButtonBlockDefaultData";
import { meta } from "./ButtonBlockMetaData";
import { ButtonEditor } from "./Editor";

/**
 * @deprecated Please use PrimaryButtonBlock or SecondaryButtonBlock instead.
 */
export const ButtonBlock: BlockExport = {
  type: "component",
  Block: Button,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-button",
    size: 24,
  },
  defaultData,
  Editor: ButtonEditor,
  meta,
};
